// extracted by mini-css-extract-plugin
export default {"button":"customers-module--button--6a827","wrapper":"customers-module--wrapper--3cdbc"};